const e = {
  name: "Breadcrumb",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3514 3.0637C15.8685 3.25762 16.1305 3.83403 15.9366 4.35115L9.9366 20.3512C9.74268 20.8683 9.16627 21.1303 8.64915 20.9364C8.13203 20.7424 7.87002 20.166 8.06394 19.6489L14.0639 3.6489C14.2579 3.13178 14.8343 2.86978 15.3514 3.0637Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as Breadcrumb
};
